import { Component, Input, ViewEncapsulation } from "@angular/core";
import {
  FlowsContractDetailsSectionElementService,
  FlowsContractDetailsSectionElementViewModel,
} from "@vattenfall/self-service";
import { Observable } from "rxjs";

@Component({
  selector: "static-loading",
  template: `
    Number of slots: {{ repeat }}
    <ul>
      <li *ngFor="let _ of repeats(repeat)">
        <!-- unnamed slot -->
        <slot></slot>
        <!-- named slot -->
        <slot name="named"></slot>
        <!-- dynamic slot -->
        <slot name="dynamic" [isStatic]="false"></slot>
        <!-- XSS slot -->
        <slot name="xss"></slot>
      </li>
    </ul>
    <hr />
    <code>{{ response | async | json }}</code>
  `,
  styles: [
    `
      :host {
        display: block;
        background: lightcyan;
        padding: 0.75rem;
        margin: 0.75rem;
      }
      hr {
        border: 1px solid white;
        opacity: 0.5;
      }
    `,
  ],
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class StaticLoadingElement {
  response?: Observable<FlowsContractDetailsSectionElementViewModel>;
  constructor(private flowsContractsDetailsSectionService: FlowsContractDetailsSectionElementService) {
    this.response = this.flowsContractsDetailsSectionService.elementsFlowsContractDetailsSectionPremisesPremiseIdGet({
      premiseId: "1",
    });
  }
  @Input() repeat = 1;
  repeats(repeat: number) {
    return Array(Number(repeat));
  }
}
